import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 내가 등록한 매물 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 거래중 입니다. ")
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 주당 가격 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 약 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 판매 금액 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 리드엔젤 성과보수 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 확인 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 팔기 취소 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 거래 취소 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 거래 확정 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          m: "32px 0px",
          "text-align": "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              dp: "block",
              "margin-bottom": "8px",
              typography: 'tit18b'
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_ag_text, {
              dp: "block",
              "margin-bottom": "8px",
              color: "gray3",
              typography: 'main14r'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.viewType === 'view' ? "구매자를 기다리고 있습니다." : "조합원 자격 거래 목록에 노출되었습니다."), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.registerResult.status === 'onSale' || _ctx.viewType === 'register']
            ]),
            _withDirectives(_createVNode(_component_ag_text, {
              dp: "block",
              "margin-bottom": "8px",
              color: "gray3",
              typography: 'main14r'
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.registerResult.status === 'inTransaction']
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ag_box, {
          style: {"flex-direction":"column"},
          dp: "flex",
          width: "100%",
          "justify-content": "space-between",
          "align-items": "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              dp: "flex",
              width: "100%",
              p: "0px 20px",
              "justify-content": "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box, {
                  "margin-bottom": "16px",
                  width: "100%",
                  dp: 'flex',
                  "align-items": 'center'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box, {
                      width: "24px",
                      height: "24px",
                      style: {"border-radius":"100%","position":"relative"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "img-circle img-responsive",
                          src: _ctx.registerResult.partnershipLogo
                        }, null, 8, _hoisted_3),
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, {
                      dp: 'inline-block',
                      "margin-left": "8px",
                      typography: 'list16m'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.registerResult.partnershipName) + " 조합원 자격 ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ag_box, {
              p: "0px 20px",
              style: {"flex-direction":"column"},
              dp: "flex",
              width: "100%"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  width: "100%",
                  "justify-content": "space-between",
                  "margin-bottom": "8px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      color: 'gray3',
                      typography: 'main14r'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ag_text, { typography: 'main14r' }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _createVNode(_component_ag_text, { typography: 'num14bk' }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.currency(_ctx.registerResult.price)), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  width: "100%",
                  "justify-content": "space-between",
                  "margin-bottom": "8px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      color: 'gray3',
                      typography: 'main14r'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ag_text, { typography: 'main14r' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_text, { typography: 'num14bk' }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.currency(_ctx.registerResult.totalPrice)), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text, { typography: 'main12r' }, {
                        default: _withCtx(() => [
                          _createTextVNode(" (약 " + _toDisplayString(_ctx.$filters.currency(_ctx.registerResult.qty)) + " 주) ", 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  "justify-content": "space-between",
                  "margin-bottom": "8px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      color: 'gray3',
                      typography: 'main14r'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ag_text, { typography: 'num14bk' }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currency(_ctx.registerResult.carriedInterest)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text, { typography: 'main14r' }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, {
      p: "20px",
      mb: "safeAreaBottom"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_ag_box, {
          dp: "flex",
          gap: "sp6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              corner: "10px",
              width: "100%",
              onClickCapture: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'확인'});_ctx.setOpen()})
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.viewType === 'register']
        ]),
        _withDirectives(_createVNode(_component_ag_box, {
          dp: "flex",
          gap: "sp6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              corner: "10px",
              outline: "primary",
              width: "100%",
              onClickCapture: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'팔기 취소'});_ctx.deleteSell()})
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.viewType === 'view' && _ctx.registerResult.status !== 'inTransaction']
        ]),
        _withDirectives(_createVNode(_component_ag_box, {
          dp: "flex",
          gap: "sp6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              corner: "10px",
              outline: "primary",
              width: "100%",
              onClickCapture: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'거래 취소'});_ctx.cancelToSell()})
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(_component_ag_button, {
              corner: "10px",
              width: "100%",
              onClickCapture: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'거래 확정'});_ctx.confirmAlert()})
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.viewType === 'view' && _ctx.registerResult.status === 'inTransaction' && _ctx.registerResult.payStatusByBuyer === 'ACCEPT']
        ])
      ]),
      _: 1
    })
  ], 64))
}